import type { ReactNode } from 'react';

import type { ResponsiveSectionLayoutSection } from '@cartwhl/ui/layout/ResponsiveSectionLayout';

import AccountDetails from './AccountDetails';
import DownloadHistory from './DownloadHistory';
import Favorites from './Favorites';
import Overview from './Overview';
import PlanBilling from './PlanBilling';
import ProfileApiKeys from './ProfileApiKeys';
import UploadedMedia from './UploadedMedia';

export const PROFILE_SECTION_SLUGS = [
  'overview',
  'my-team',
  'favorites',
  'download-history',
  'uploaded-media',
  'account-details',
  'plan-billing',
  'api-keys',
] as const;

export type ProfileSectionSlug = (typeof PROFILE_SECTION_SLUGS)[number];

export interface ProfileSection
  extends ResponsiveSectionLayoutSection<ProfileSectionSlug> {}

export interface GetProfileSectionsOptions {
  myTeamContent: ReactNode;
  myTeamMaxWidthClassName?: string;
}

export function getProfileSections({
  myTeamContent,
  myTeamMaxWidthClassName,
}: GetProfileSectionsOptions): ProfileSection[] {
  return [
    {
      slug: 'overview',
      label: 'Overview',
      content: <Overview />,
    },
    {
      slug: 'my-team',
      label: 'My Team',
      content: myTeamContent,
      maxWidthClassName: myTeamMaxWidthClassName,
    },
    {
      slug: 'favorites',
      label: 'Favorites',
      content: <Favorites />,
    },
    {
      slug: 'download-history',
      label: 'Download History',
      content: <DownloadHistory />,
    },
    {
      slug: 'uploaded-media',
      label: 'Uploaded videos',
      content: <UploadedMedia />,
    },
    {
      slug: 'account-details',
      label: 'Account Details',
      content: <AccountDetails />,
    },
    {
      slug: 'plan-billing',
      label: 'Plan & Billing',
      content: <PlanBilling />,
    },
    {
      slug: 'api-keys',
      label: 'API Keys',
      content: <ProfileApiKeys />,
      maxWidthClassName: 'max-w-(--breakpoint-lg)',
    },
  ];
}

export function findProfileSection(
  sections: ProfileSection[],
  slug?: string,
): ProfileSection | undefined {
  return sections.find((section) => section.slug === slug);
}
